var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 207,
    viewBox: "0 0 248 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 204.466H247.075",
    stroke: "#00214D",
    strokeWidth: 3.10138
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M123.12 182.327C173.468 182.327 214.284 141.511 214.284 91.1633C214.284 40.815 173.468 0 123.12 0C72.7721 0 31.957 40.815 31.957 91.1633C31.957 141.511 72.7721 182.327 123.12 182.327Z",
    fill: "#00214D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.683 33.6105L124.682 36.4458L121.476 32.3423C122.93 33.3034 123.452 33.5232 124.683 33.6105Z",
    fill: "#00214D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.971 31.0998L121.139 26.5867C120.338 25.2324 119.068 22.2876 120.399 21.3413C121.731 20.395 123.787 22.3489 124.649 23.4443C124.912 20.991 126.025 16.1806 128.373 16.5661C130.721 16.9517 130.9 15.5926 131.15 14.7271L130.184 13.5817L128.881 12.4812C127.056 10.8656 121.497 8.8041 115.898 13.7912C110.298 18.7783 114.947 27.4081 117.971 31.0998Z",
    fill: "#00214D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.546 32.1053C122.281 32.8539 124.504 34.2074 127.522 33.6309C128.166 33.5076 128.736 33.3652 129.236 33.2137C131.443 32.5456 132.808 30.4885 133.232 28.2225C133.592 26.2977 133.781 24.0045 133.243 21.9338C132.362 18.5434 131.28 16.3454 130.672 15.5542",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.966 29.5151L117.304 36.7386",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.571 33.6255V37.6172",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.822 67.9678L104.576 79.3528",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.662 73.7682L151.404 67.5718L156.356 74.5245L138.403 88.287",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M152.428 68.9811C153.132 68.9361 154.309 67.7135 154.831 66.6977C156.258 63.9221 158.723 60.3574 162.182 64.176C164.949 67.2309 163.037 69.6712 161.794 70.6296C160.065 71.6995 158.3 71.1255 156.97 72.2395C155.64 73.3536 155.818 73.1308 155.533 73.3403",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M113.766 95.9227L118.405 97.3966L120.838 98.8861C121.036 99.7794 121.781 101.656 123.171 102.013C124.561 102.371 126.497 101.666 127.291 101.269C128.251 100.806 129.913 99.4619 128.88 97.794C127.847 96.126 126.596 95.2785 126.1 95.0634L122.277 93.723L116.585 91.855",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.447 144.739L112.449 113.455H138.086L157.862 187.896L148.49 190.388C138.59 173.361 133.371 151.9 132.447 144.739Z",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.332 113.495L99.3047 149.459L83.6777 184.086L93.0598 187.878L114.275 154.649L121.462 127.302",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.715 194.735L150.296 198.255L151.921 202.646C152.373 203.867 153.725 204.494 154.949 204.05L172.69 197.604C173.74 196.327 172.253 195.762 171.378 195.639L159.715 194.735Z",
    fill: "#00214D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.169 189.671L153.276 198.252",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.79 188.339L158.009 196.477",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8374 193.72L81.5311 189.913L79.7442 194.24C79.2474 195.444 79.8155 196.822 81.016 197.326L98.4204 204.633C100.058 204.407 99.3489 202.983 98.7897 202.299L90.8374 193.72Z",
    fill: "#00214D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3399 184.708L82.999 191.934",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6303 186.815L87.3145 193.994",
    stroke: "#00214D",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.64 66.097C157.996 65.4416 159.098 64.2518 160.648 64.7376",
    stroke: "#00214D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.854 67.9762C159.211 67.3205 160.312 66.1307 161.863 66.6165",
    stroke: "#00214D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.831 95.936L125.767 95.3385C125.758 95.2513 125.716 95.1687 125.644 95.1096L125.831 95.936ZM125.831 95.936L126.21 95.4695L140.299 78.1156L140.104 77.958L140.299 78.1156C141.57 76.5493 141.331 74.249 139.765 72.9772L139.765 72.9772L124.137 60.2897C124.137 60.2897 124.137 60.2897 124.137 60.2897C122.571 59.0181 120.271 59.257 118.999 60.8233L103.968 79.3379L103.811 79.5312L104.003 79.6889L104.69 80.2514L104.884 80.4105L105.043 80.2156L120.077 61.698L119.882 61.5404L120.077 61.698C120.865 60.7266 122.292 60.5784 123.263 61.367L138.891 74.0545C139.862 74.843 140.01 76.2696 139.221 77.2409L125.134 94.593L124.756 95.058L125.352 94.9994C125.439 94.9908 125.529 95.0153 125.601 95.075L125.602 95.0752L125.644 95.1095L125.831 95.936ZM98.6628 86.2702L98.4686 86.1111L98.3103 86.3061L97.151 87.7341L97.3282 87.8779L97.151 87.7341C95.8795 89.3003 96.1183 91.601 97.6846 92.8725L113.312 105.56C114.878 106.832 117.179 106.593 118.45 105.027L118.274 104.883L118.45 105.027L121.944 100.723L122.359 100.212L121.709 100.319C121.615 100.335 121.516 100.311 121.437 100.246L121.396 100.212L121.395 100.212C121.328 100.157 121.288 100.084 121.275 100.005L121.182 99.4603L120.834 99.889L117.373 104.152C116.584 105.123 115.158 105.271 114.187 104.483L114.029 104.677L114.187 104.483L98.5593 91.7952L98.4024 91.9884L98.5593 91.7951C97.5879 91.0066 97.4398 89.5801 98.2283 88.6088L99.3853 87.1837L99.5422 86.9905L99.3496 86.8327L98.6628 86.2702Z",
    fill: "#00214D",
    stroke: "#00214D",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.334 70.0874L135.334 70.0878C135.353 70.2065 135.371 70.3253 135.39 70.4444L135.391 70.4503L135.407 70.5551L135.494 70.6161L136.502 71.3254L136.983 71.6634L136.893 71.0828C136.831 70.6778 136.768 70.2743 136.705 69.8722L136.705 69.8722C135.522 62.3456 134.192 55.3418 132.752 49.885C132.032 47.1577 131.28 44.7995 130.498 42.9488L130.498 42.9488C129.729 41.127 128.89 39.6943 127.946 38.9278C124.587 36.1978 121.15 35.5801 118.338 35.9017L118.357 36.0678L118.338 35.9017C115.57 36.2183 113.363 37.4527 112.452 38.5049L112.452 38.5052L112.444 38.5138L112.439 38.5193L112.435 38.5251L112.43 38.5323L112.428 38.534L97.6869 57.4418L97.6861 57.4428L97.6825 57.4474L97.6824 57.4474L97.6777 57.4537L97.6735 57.4594L97.6727 57.4605L86.4386 72.8605L86.4383 72.8609L86.4203 72.8858L86.4101 72.8998L86.4019 72.9152L86.3877 72.9418C86.3876 72.942 86.3875 72.9421 86.3875 72.9423C85.6675 74.2866 85.36 77.422 88.6115 80.3312L88.6286 80.3467L88.6395 80.3565L88.6515 80.365L88.6693 80.3775L88.6708 80.3786L112.599 97.5692L112.599 97.5692L112.969 97.8352L113.178 97.9851L113.322 97.7726L113.578 97.3954L113.578 97.3953L117.875 91.0649L117.875 91.0649L118.097 90.7377L118.222 90.5533L118.054 90.4079L117.754 90.1495L117.754 90.1495L99.3083 74.2643L109.737 65.6218L109.929 65.4622L109.77 65.2697L109.203 64.5862L109.043 64.3938L108.851 64.5533L97.7906 73.7199L97.3861 74.0552L97.1583 74.244L97.3825 74.4371L97.7805 74.7797L97.7805 74.7798L116.38 90.7975L112.83 96.0265L89.5095 79.2726C86.8015 76.8316 87.1863 74.4436 87.5909 73.6358L98.7874 58.2871L113.512 39.4005C114.153 38.6713 116 37.5658 118.495 37.2806L118.469 37.0511L118.495 37.2806C120.961 36.9986 124.019 37.5249 127.072 40.0047C127.731 40.5408 128.462 41.6944 129.22 43.4886C129.966 45.2547 130.698 47.543 131.41 50.2392C132.833 55.6291 134.154 62.5796 135.334 70.0874ZM138.173 80.0004L138.099 79.4448L137.735 79.8715L136.961 80.7805L136.889 80.8652L136.904 80.9755C138.438 92.5372 139.613 104.236 140.298 112.761H101.854L103.545 96.2646L103.571 96.0159L103.322 95.9904L102.439 95.8999L102.191 95.8744L102.165 96.1231L100.396 113.384L100.396 113.384L100.345 113.873L100.317 114.149H100.594H101.086H141.049H141.529H141.8L141.779 113.879L141.741 113.4C141.048 104.609 139.809 92.1893 138.173 80.0004Z",
    fill: "#00214D",
    stroke: "#00214D",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.725 86.2749C120.575 86.2749 122.075 84.7751 122.075 82.925C122.075 81.075 120.575 79.5752 118.725 79.5752C116.875 79.5752 115.375 81.075 115.375 82.925C115.375 84.7751 116.875 86.2749 118.725 86.2749Z",
    fill: "#00214D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7723 66.447C74.6427 66.447 81.8337 59.256 81.8337 50.3856C81.8337 41.5151 74.6427 34.3242 65.7723 34.3242C56.9019 34.3242 49.7109 41.5151 49.7109 50.3856C49.7109 59.256 56.9019 66.447 65.7723 66.447Z",
    stroke: "#00214D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7969 52.0781C54.33 55.2265 59.8367 57.0729 65.7724 57.0729C71.7082 57.0729 77.2148 55.2265 81.748 52.0781",
    stroke: "#00214D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7451 52.0783C77.2119 48.9299 71.7052 47.0835 65.7695 47.0835C59.8338 47.0835 54.3271 48.9299 49.7939 52.0783",
    stroke: "#00214D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6631 66.3613C70.8114 61.8281 72.6578 56.3214 72.6578 50.3857C72.6578 44.45 70.8114 38.9433 67.6631 34.4102",
    stroke: "#00214D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7008 34.4102C61.5525 38.9433 59.7061 44.45 59.7061 50.3857C59.7061 56.3214 61.5525 61.8281 64.7008 66.3613",
    stroke: "#00214D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_27588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 52,
    width: 19,
    height: 18
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.414 52.0781H197.956V69.5361H215.414V52.0781Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M214.526 68.5005C214.526 66.4606 214.125 64.4405 213.344 62.5556C212.563 60.671 211.419 58.9584 209.976 57.5159C208.534 56.0733 206.821 54.9291 204.937 54.1482C203.052 53.3677 201.032 52.9658 198.992 52.9658V68.5005H214.526Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_27588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.526 68.5005C214.526 66.4606 214.124 64.4405 213.343 62.5556C212.563 60.671 211.418 58.9584 209.976 57.5159C208.533 56.0733 206.821 54.9291 204.936 54.1482C203.051 53.3677 201.031 52.9658 198.991 52.9658V68.5005H214.526Z",
    stroke: "#00214D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.323 57.1084L206.833 50.3027",
    stroke: "#00214D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.803 65.0977L214.526 51.7822",
    stroke: "#00214D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.833 68.9443L216.006 59.7715",
    stroke: "#00214D",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_264_27588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 54,
    width: 34,
    height: 35
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M195.737 54.7412C192.43 54.7412 189.198 55.7218 186.449 57.5588C183.699 59.3957 181.556 62.0067 180.291 65.0616C179.026 68.1164 178.695 71.4781 179.34 74.7212C179.985 77.9642 181.577 80.943 183.915 83.2812C186.253 85.6191 189.232 87.2113 192.475 87.8564C195.718 88.5014 199.08 88.1706 202.135 86.9051C205.19 85.6398 207.801 83.4969 209.638 80.7477C211.474 77.9982 212.455 74.7661 212.455 71.4595H195.737V54.7412Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_264_27588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.737 54.7412C192.43 54.7412 189.198 55.7218 186.449 57.5588C183.699 59.3957 181.556 62.0067 180.291 65.0616C179.026 68.1164 178.695 71.4781 179.34 74.7212C179.985 77.9642 181.577 80.943 183.915 83.2812C186.253 85.6191 189.232 87.2113 192.475 87.8564C195.718 88.5014 199.08 88.1706 202.135 86.9051C205.19 85.6398 207.801 83.4969 209.638 80.7477C211.474 77.9982 212.455 74.7661 212.455 71.4595H195.737V54.7412Z",
    fill: "#00214D",
    stroke: "#00214D",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.d7fb3cd6c5458c1b8f29a3211534829e.svg";
export { ForwardRef as ReactComponent };